export default __webpack_public_path__ + "static/media/goBack.ac049261.svg";